<div class="flex flex-column consult__section consult__history-family">
  <div class="col-12 inline-flex flex-wrap consult__section-subheading-group">
    <h3 class="col-12 inline-flex align-items-center lg:col-4 p-0 consult__section-subheading cursor-pointer"
      (click)="expandSection = !expandSection">
      <i class="fas" [style.fontSize.px]="12" [ngClass]="{
        'fa-minus': expandSection,
        'fa-plus': !expandSection
      }"></i>
      <label class="ml-2 mb-0 cursor-pointer" for="history-family-detail">{{screen.heading}}</label>
    </h3>

    <span class="col-12 lg:col-8 p-0 consult__section-help">{{screen.tooltip}}</span>
  </div>

  <span class="inline-flex flex-column col-12 px-0" *ngIf="expandSection">
    <textarea pInputTextarea name="history-family-detail" [(ngModel)]="mainDetail"
      (ngModelChange)="handleDescriptionChange()" [rows]="4" class="uppercase m-0" [required]="true"
      validation></textarea>

    <small class="py-2">
      {{screen.disclaimer}} {{historiesName}}
    </small>

    <div class="mt-2 align-self-end">
      <p-button [label]="screen.showDetail" (onClick)="showDetails = true"></p-button>
    </div>
  </span>
</div>

<p-sidebar [(visible)]="showDetails" position="right" [blockScroll]="true" appendTo="body"
  [style]="{ width: '425px', maxWidth: '90%' }">
  <div class="inline-flex flex-column">
    <h3 class="text-base font-normal mb-2">
      {{screen.detailDescription}}
    </h3>

    <div *ngFor="let history of histories">
      <ms-history-item [history]="history"></ms-history-item>
    </div>
  </div>
</p-sidebar>